import { StrictOmit } from '@streamloots/streamloots-types';
import type { PushInputProps } from './PushInput';
import { PushInput } from './PushInput';

export type CheckboxProps = StrictOmit<PushInputProps, 'type'>;

export const Checkbox = (props: CheckboxProps): JSX.Element => <PushInput {...props} type="checkbox" />;
